import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CodeSoruSor from '../components/CodeSoruSor';

function formatShortDate(dateString) {
  if (!dateString) return 'Yakın zamanda';
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMin = Math.floor(diffMs / 60000);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffMin < 1) return 'az önce';
  if (diffMin < 60) return `${diffMin} dk önce`;
  if (diffHour < 24) return `${diffHour} saat önce`;
  if (diffDay < 7) return `${diffDay} gün önce`;
  return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' });
}

function Code({ user, posts = [], addPost }) {
  const navigate = useNavigate();
  const [copiedId, setCopiedId] = useState(null);

  const codePosts = posts.filter(p => Array.isArray(p.tags) && p.tags.includes('code-question'));

  const handleCopyCode = (id, codeText) => {
    navigator.clipboard.writeText(codeText);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  return (
    <div className="code-page" style={{ padding: '20px 0' }}>
      <CodeSoruSor addPost={addPost} user={user} />

      <div className="past-questions" style={{ marginTop: '32px' }}>
        <h3 style={{ marginBottom: '14px' }}>Son Paylaşılan Kodlar</h3>

        {codePosts.length === 0 ? (
          <p style={{ color: 'var(--muted)', background: 'var(--bg)', padding: '20px', borderRadius: '8px' }}>
            Henüz hiç kod paylaşılmamış. İlk paylaşımı sen yap!
          </p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {codePosts.map(post => {
              const codeText = post.body || post.code || post.code_snippet || post.content || post.description || '';
              const authorName = post.author?.username || (typeof post.author === 'string' ? post.author : null) || 'Anonim';
              const language = (post.tags || []).find(t => t !== 'code-question') || 'code';
              const previewLine = codeText.split('\n').find(l => l.trim()) || codeText;

              return (
                <div
                  key={post.id}
                  onClick={() => navigate(`/post/${post.id}`)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '14px',
                    border: '1px solid #eaeaea',
                    borderRadius: '10px',
                    padding: '14px 16px',
                    backgroundColor: '#fff',
                    cursor: 'pointer',
                    transition: 'box-shadow 0.15s ease, border-color 0.15s ease'
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.06)'; e.currentTarget.style.borderColor = '#d6e4f5'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = '#eaeaea'; }}
                >
                  {/* Dil rozeti */}
                  <div style={{
                    flexShrink: 0,
                    width: '46px',
                    height: '46px',
                    borderRadius: '8px',
                    background: '#1e1e1e',
                    color: '#61dafb',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '11px',
                    fontWeight: 700,
                    fontFamily: 'monospace',
                    textTransform: 'uppercase'
                  }}>
                    {String(language).slice(0, 2)}
                  </div>

                  {/* Başlık + tek satır kod önizlemesi */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: '15px', color: 'var(--ink)', marginBottom: '3px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {post.title}
                    </div>
                    <div style={{
                      fontFamily: 'monospace',
                      fontSize: '12.5px',
                      color: 'var(--muted)',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>
                      {previewLine}
                    </div>
                    <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '4px' }}>
                      @{authorName} • {formatShortDate(post.created_at)} • {post.comment_count ?? 0} yorum
                    </div>
                  </div>

                  {/* Kopyala */}
                  <button
                    onClick={(e) => { e.stopPropagation(); handleCopyCode(post.id, codeText); }}
                    style={{
                      flexShrink: 0,
                      background: '#f4f6fb',
                      border: '1px solid #e1e6ef',
                      borderRadius: '6px',
                      padding: '6px 10px',
                      fontSize: '12px',
                      color: '#435270',
                      cursor: 'pointer'
                    }}
                  >
                    {copiedId === post.id ? '✓' : '📋'}
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default Code;